import { Loader } from '@googlemaps/js-api-loader';

// create google api loader
export const mapsLoader = new Loader({
  apiKey: "AIzaSyDYzvTtx6h1jVcwLwdhWiMkDKUhS-Z_PzM",
  version: "weekly",
  libraries: ["places"]
});

export const distanceServiceOptions = {
  // origins: [origin1, origin2],
  // destinations: [destinationA, destinationB],
  travelMode: 'DRIVING',
  avoidHighways: false
}